import { InputAdornment, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { alert } from "src/services/alert";
import { asyncRequest } from "src/services/network";
import { logout } from "src/store/reducers/userInfo";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";

const ChangePwdDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    // nickname: "",
    password: "",
    passwordNew: "",
    passwordNew2: "",
    // mobile: "",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    const { password, passwordNew, passwordNew2 } = form;
    if (passwordNew !== passwordNew2) return alert("两次密码不一致");
    if (password === passwordNew) return alert("新密码和旧密码一样");

    const { msg } = await asyncRequest({
      path: "/system/admin/changePwd",
      data: form,
    });

    setForm({
      password: "",
      passwordNew: "",
      passwordNew2: "",
    });
    alert(msg, "success");
    onClose();
    dispatch(logout());
  }

  return (
    <FormDialog title="修改密码" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="旧密码">
        <TextField fullWidth type="password" placeholder="旧密码" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
      </FormItem>

      <FormItem title="新密码">
        <TextField
          fullWidth
          type="password"
          placeholder="新密码"
          autoComplete="off"
          id="passwordNew"
          value={form.passwordNew}
          size="small"
          inputProps={{
            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
          }}
          onChange={(e) => handleIptChange("passwordNew", e.target.value)}
        />
      </FormItem>

      <FormItem title="确认密码">
        <TextField fullWidth type="password" placeholder="确认密码" autoComplete="off" id="passwordNew2" value={form.passwordNew2} size="small" onChange={(e) => handleIptChange("passwordNew2", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default ChangePwdDialog;
